import { Add, Search } from '@mui/icons-material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { Box, Collapse, Divider, InputAdornment } from '@mui/material';
import { ILayoutFields, ISchemaFields, ISchemaForm, IUiFields } from 'modules/common/SchemaForm/utils';
import { THERAPY_STATUS } from 'modules/reception/constants';
import { Sort } from '../../../../../svg';
import { ORDER_BE } from '../../../../common/constants';

export const fieldSchema: ISchemaFields = ({ valuesField, formProps, methods }) => {
  const { intl, onRegister, clearParams, state, setState, onDataLoading } = formProps || {};
  const { setValue } = methods;
  return {
    patientName: {
      type: 'text-field',
      placeholder: intl.formatMessage({ id: 'sale.customerEnter' }),
      propsWrapper: { xs: true },
      label: intl.formatMessage({ id: 'sellingProduct.title.customerName' }),
      noHelperText: true,
    },
    patientMobilePhone: {
      type: 'text-field',
      placeholder: intl.formatMessage({ id: 'telephoneEnter' }),
      propsWrapper: { xs: true },
      InputProps: {
        startAdornment: (
          <InputAdornment position="start">
            <Search color="inherit" />
          </InputAdornment>
        ),
      },
      showClearBtn: true,
    },
    status: {
      type: 'select',
      hasAllOptions: true,
      label: intl.formatMessage({ id: 'status' }),
      options: THERAPY_STATUS,
      noHelperText: true,
      propsWrapper: { xs: true },
    },
    patientCode: {
      type: 'text-field',
      label: intl.formatMessage({ id: 'therapy.label.customer.code' }),
      placeholder: intl.formatMessage({ id: 'therapy.label.customer.enterCode' }),
      noHelperText: true,
      propsWrapper: { xs: true },
    },
    search: {
      type: 'submitButton',
      color: 'inherit',
      label: intl.formatMessage({ id: 'search' }),
      propsWrapper: { xs: undefined },
    },
    expand: {
      type: 'button',
      endIcon: (
        <ExpandLessIcon
          style={{
            transition: '0.2s all',
            transform: valuesField?.expand ? 'rotate(0deg)' : 'rotate(180deg)',
          }}
        />
      ),
      color: 'primary',
      variant: 'text',
      onClick: () => setState({ expand: !state.expand }),
      label: intl.formatMessage({ id: 'advance' }),
      propsWrapper: { xs: undefined },
    },
    add: {
      type: 'button',
      color: 'secondary',
      startIcon: <Add />,
      label: intl.formatMessage({ id: 'therapyList.button.create' }),
      propsWrapper: { xs: undefined },
      onClick: onRegister,
    },
    reset: {
      type: 'button',
      onClick: () => clearParams && clearParams(),
      color: 'inherit',
      label: intl.formatMessage({ id: 'reset' }),
      propsWrapper: { xs: undefined },
      style: { minWidth: 120, marginTop: 20 },
    },
    orderBy: {
      type: 'submitButton',
      onClick: () => {
        if (!valuesField?.orderBy || valuesField.orderBy === ORDER_BE.asc) {
          setValue('orderBy', ORDER_BE.desc);
          return;
        }
        setValue('orderBy', ORDER_BE.asc);
      },
      disabled: onDataLoading,
      label: intl.formatMessage({ id: 'encounterList.label.input.sort' }),
      style: { minWidth: 120 },
      propsWrapper: { xs: undefined },
      color: 'inherit',
      startIcon: (
        <Box
          sx={{
            transition: 'all 0.3s ease',
            transform: valuesField.orderBy === ORDER_BE.asc ? 'rotate(180deg)' : 'rotate(0deg)',
            '& path': {
              fill: onDataLoading ? '#A8A8AA' : '#0962FF',
            },
          }}
        >
          <Sort />
        </Box>
      ),
    },
  };
};

const ui: IUiFields = () => {
  return [
    {
      id: 'layout',
      propsGridContainer: { spacing: 1, justifyContent: 'flex-end' },
      fields: ['patientMobilePhone', 'search', 'orderBy', 'expand', 'add'],
    },
    {
      id: 'expand',
      fields: ['patientName', 'status', 'patientCode', 'reset'],
    },

    { id: 'submit', fields: ['save'] },
  ];
};

const LayoutSchema: ILayoutFields = (props) => {
  const { listElement, formProps } = props;
  const { state } = formProps;
  return (
    <>
      <Box display="flex">
        <Box flex={1}>{formProps?.pagin}</Box>
        <Box flex={1}>{listElement[0]}</Box>
      </Box>
      <Collapse in={state?.expand} style={{ marginTop: 16 }}>
        {listElement[1]}
        <Divider style={{ marginBottom: 16, marginTop: 16 }} />
      </Collapse>
    </>
  );
};

export const schemaFilterTherapyForm: ISchemaForm = {
  fields: fieldSchema,
  ui: ui,
  layout: LayoutSchema,
};
